const PREFIX = "Shared/Property/";

export const RECEIVE_PROPERTY = `${PREFIX}RECEIVE_PROPERTY`;
export const RECEIVE_PROPERTIES = `${PREFIX}RECEIVE_PROPERTIES`;
export const UPDATE_PROPERTY = `${PREFIX}UPDATE_PROPERTY`;
